import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../config.js";
import { toast } from "react-toastify";

const Notifications = (ComponentToRenderData) => {
    let history = useHistory();
    const params = useParams();
    const SystemUrl = ComponentToRenderData.SystemUrl;
    const token = localStorage.getItem('token')
    const search = window.location.search;
    let URLParams = new URLSearchParams(search);
    const [data, setData] = useState([]);
    const [countsData, setCountsData] = useState({});
    const [iconsData, setIconsData] = useState({});
    const [TotalData, setTotalData] = useState({});
    const routeChange = path => {
        history.push(path);
    }
    const $ = require("jquery");
    const [notificationToggle, setNotificationToggle] = useState(false)
    $(document).on('click', "a[data-dropdown='notificationMenu']", function (e) {
        e.preventDefault();
        var el = $(e.currentTarget);
        $('body').prepend('<div id="dropdownOverlay" style="background: transparent; height:100%;width:100%;position:fixed;"></div>')
        var container = $(e.currentTarget).parent();
        var dropdown = container.find('.dropdown');
        var containerWidth = container.width();
        dropdown.css({
            'right': containerWidth / 2 + 'px'
        })


    });

    const toggleNotification = (event) => {
        let state = $(event.currentTarget).hasClass('expanded');
        if (notificationToggle) {
            $(event.currentTarget).removeClass('expanded')
            setNotificationToggle(true)
        } else {
            $(event.currentTarget).addClass('expanded')
            setNotificationToggle(false)
        }
    }

    const toggleBell = (e) => {
        console.log('toggleBell')

        var container = $(e.currentTarget).parent();
        let state = $(container).hasClass('expanded');
        if (state) {
            $(container).removeClass('expanded')
        } else {
            $(container).addClass('expanded')
        }
    }

    $(document).on('click', '#dropdownOverlay', function (e) {
        var el = $(e.currentTarget)[0].activeElement;

        if (typeof $(el).attr('data-dropdown') === 'undefined') {
            $('#dropdownOverlay').remove();
            $('.dropdown-container.expanded').removeClass('expanded');
        }
    })

    $('.notification-tab').click(function (e) {
        if ($(e.currentTarget).parent().hasClass('expanded')) {
            $('.notification-group').removeClass('expanded');
        }
        else {
            $('.notification-group').removeClass('expanded');
            $(e.currentTarget).parent().toggleClass('expanded');
        }
    })
    useEffect(() => {
        getNotification()
    }, [])
    const getNotification = () => {

        axios(config.SystemUrl + `Notification`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization': "Bearer " + token
            }
        })
            .then(result => {
                if (result.data.hasOwnProperty('data')) {
                    setData(Object.entries(result.data.data))
                    setCountsData(result.data['counts']);
                    setIconsData(result.data['icons']);
                    setTotalData(result.data['total']);
                }
            });
    }
    return (
        <>
            <div className="dropdown-container">
                <a onClick={toggleBell} href="#" data-dropdown="notificationMenu" className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px menu-link has-notifications circle notificationMenu">
                    <span className="svg-icon svg-icon-1">
                        <i className="bi bi-bell  fs-1"></i>
                        {TotalData && TotalData > 0 ?
                            <span className="total_span">{TotalData}</span> : ''
                        }
                    </span>
                </a>

                <ul className="dropdown" name="notificationMenu">
                    {data.length == 0 ?
                        <li className="notification-group">
                            <div className="notification-tab pt-3 text-center">
                                <h4>No Notifications</h4>
                            </div>
                        </li> :
                        data.map((notifications, index) => (
                            <li key={index} onClick={toggleNotification} className={"notification-group "}>
                                <div className="notification-tab">
                                    <i className={iconsData[notifications[0]]}></i>
                                    <h4>{notifications[0]}</h4>
                                    <span className="label">
                                        {countsData[notifications[0]]}
                                    </span>
                                </div>
                                <ul className="notification-list">
                                    {notifications[1].map((notification, index) => (
                                        <li className="notification-list-item"
                                            style={{ backgroundColor: notification.is_read == 0 ? '#ccc' : 'transparent' }}
                                            key={index}
                                            onClick={() => {
                                                if (notification.is_read == 0) {
                                                    axios.get(config.SystemUrl + `MarkAsRead?id=${notification.id}`).then(result => {
                                                        getNotification()
                                                    })
                                                }
                                            }}>
                                            <Link to={'/' + notification.url}>
                                                <p className="message">{notification.text}</p>
                                                <div className="item-footer">
                                                    <span className="date">{notification.date}</span>
                                                </div>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}


                </ul>
            </div>
        </>
    );

}
export default Notifications;
